// Template dokumen dan foto wajib per-step untuk setiap proses
// fotoWajib urutan 1 default = Rehab (rumah existing). Pembangunan override via getTemplate().
export const ADMIN_TEMPLATE = [
  { urutan: 1, tahap: 'Usulan/Proposal Penerima Bantuan', bobot: 5,
    dokumenWajib: ['Proposal', 'KTP', 'KK', 'Surat Pernyataan'],
    fotoWajib: ['Depan', 'Belakang', 'Kiri', 'Kanan', 'Dalam'] },
  { urutan: 2, tahap: 'Validasi Faktual & Survei', bobot: 10,
    dokumenWajib: ['Form Validasi (Data Sistem)', 'BA Survei (Otomatis)'],
    fotoWajib: ['Foto survei bersama pendamping'] },
  { urutan: 3, tahap: 'Penyusunan RAB & Gambar', bobot: 10,
    dokumenWajib: ['RAB', 'Gambar Teknis', 'Rekap Volume (opsional)'],
    fotoWajib: [] },
  { urutan: 4, tahap: 'Penetapan Penerima Bantuan', bobot: 5,
    dokumenWajib: ['SK Penetapan'],
    fotoWajib: [] },
  { urutan: 5, tahap: 'Sosialisasi', bobot: 5,
    dokumenWajib: ['Undangan', 'Daftar Hadir', 'Notulen'],
    fotoWajib: ['Foto kegiatan 1', 'Foto kegiatan 2', 'Foto kegiatan 3'] },
  { urutan: 6, tahap: 'SPK/Kontrak', bobot: 10,
    dokumenWajib: ['SPK/Kontrak PPK dengan AGR', 'SPK/Kontrak PPK dengan Supplier'],
    fotoWajib: ['Foto ttd kontrak AGR', 'Foto ttd kontrak Supplier'] },
  { urutan: 7, tahap: 'Pemblokiran Rekening', bobot: 5,
    dokumenWajib: ['Surat Pemblokiran ke Bank', 'Surat Pembuka Rekening Dana Penerima (opsional)'],
    fotoWajib: [] },
  { urutan: 8, tahap: 'Transfer Dana dari Dinas ke Penerima Bantuan', bobot: 10,
    dokumenWajib: ['BAP (Berita Acara Pembayaran)', 'SPM', 'Kwitansi Pembayaran ke Penerima'],
    fotoWajib: [] },
  { urutan: 9, tahap: 'Pemeriksaan Akhir & BAST', bobot: 15,
    dokumenWajib: ['BAST', 'NPHD (Naskah Perjanjian Hibah Daerah)'],
    fotoWajib: ['Tampak depan', 'Tampak belakang', 'Tampak kiri', 'Tampak kanan'] },
  { urutan: 10, tahap: 'SPJ Lengkap & Disetujui', bobot: 25,
    dokumenWajib: ['SPJ Final'],
    fotoWajib: [], spjAutoFill: true },
];

export const KEUANGAN_TEMPLATE = [
  { urutan: 1, tahap: 'Dana diterima di rekening penerima', bobot: 10,
    dokumenWajib: ['Bukti Transfer', 'Surat Pemblokiran Rekening'],
    fotoWajib: [], fotoOptional: false, syncedFromAdm: true },
  { urutan: 2, tahap: 'Droping Material Tahap I', bobot: 15,
    dokumenWajib: ['Nota'],
    fotoWajib: ['Foto Droping Material'], fotoOptional: false },
  { urutan: 3, tahap: 'Pembayaran Supplier Tahap I', bobot: 20,
    dokumenWajib: ['Bukti Transfer'],
    fotoWajib: [], fotoOptional: false, perSupplierBukti: true },
  { urutan: 4, tahap: 'Droping Material Tahap II', bobot: 15,
    dokumenWajib: ['Nota'],
    fotoWajib: ['Foto Droping Material'], fotoOptional: false },
  { urutan: 5, tahap: 'Pembayaran Supplier Tahap II', bobot: 20,
    dokumenWajib: ['Bukti Transfer'],
    fotoWajib: [], fotoOptional: false, perSupplierBukti: true },
  { urutan: 6, tahap: 'UPLOAD PENGAMBILAN FORM PENGAMBILAN UPAH KERJA TAHAP 1', bobot: 10,
    dokumenWajib: ['Form Pengambilan Upah Tahap 1', 'Bukti Transfer'],
    fotoWajib: [], fotoOptional: false },
  { urutan: 7, tahap: 'UPLOAD PENGAMBILAN FORM PENGAMBILAN UPAH KERJA TAHAP 2', bobot: 10,
    dokumenWajib: ['Form Pengambilan Upah Tahap 2', 'Bukti Transfer'],
    fotoWajib: [], fotoOptional: false },
];

export const FISIK_TEMPLATE = [
  { urutan: 1, tahap: 'Persiapan', bobot: 5,
    fotoWajib: ['Foto lahan sebelum pekerjaan'] },
  { urutan: 2, tahap: 'Pondasi', bobot: 10,
    fotoWajib: ['Foto galian', 'Foto pasangan pondasi'] },
  { urutan: 3, tahap: 'Sloof', bobot: 8,
    fotoWajib: ['Foto pembesian', 'Foto pengecoran'] },
  { urutan: 4, tahap: 'Kolom', bobot: 8,
    fotoWajib: ['Foto pembesian', 'Foto kolom selesai'] },
  { urutan: 5, tahap: 'Dinding', bobot: 15,
    fotoWajib: ['Foto seluruh sisi dinding'] },
  { urutan: 6, tahap: 'Ring Balok', bobot: 8,
    fotoWajib: ['Foto pembesian', 'Foto pengecoran'] },
  { urutan: 7, tahap: 'Rangka Atap', bobot: 10,
    fotoWajib: ['Foto rangka atap'] },
  { urutan: 8, tahap: 'Penutup Atap', bobot: 10,
    fotoWajib: ['Foto atap selesai'] },
  { urutan: 9, tahap: 'Lantai', bobot: 8,
    fotoWajib: ['Foto lantai selesai'] },
  { urutan: 10, tahap: 'Pintu & Jendela', bobot: 6,
    fotoWajib: ['Foto pintu & jendela terpasang'] },
  { urutan: 11, tahap: 'Sanitasi', bobot: 5,
    fotoWajib: ['Foto kamar mandi', 'Foto septic tank', 'Foto saluran'] },
  { urutan: 12, tahap: 'Finishing & Rumah Selesai', bobot: 7,
    fotoWajib: ['Foto depan', 'Foto belakang', 'Foto kiri', 'Foto kanan', 'Foto dalam'] },
];

/**
 * Ambil template step. Untuk administrasi urutan 1:
 * - Pembangunan Rumah Layak Huni → foto hanya "Foto 0% (Lokasi Tanah)"
 * - Rehab / lainnya → foto tampak depan/belakang/kiri/kanan/dalam
 */
export function getTemplate(tipe, urutan, jenisBantuan = '') {
  const map = { administrasi: ADMIN_TEMPLATE, keuangan: KEUANGAN_TEMPLATE, fisik: FISIK_TEMPLATE };
  const list = map[tipe] || [];
  const base = list.find(t => t.urutan === urutan) || null;
  
  // Rehab fisik manual: langkah tidak match template default,
  // gunakan foto label generik berdasarkan nama tahap yang diisi manual
  if (tipe === 'fisik' && /rehab/i.test(String(jenisBantuan || ''))) {
    return {
      urutan,
      tahap: null, // caller yang isi
      fotoWajib: ['Foto sebelum', 'Foto proses', 'Foto sesudah'],
      isManualRehab: true,
    };
  }
  
  if (!base) return null;

  const isPembangunan = /pembangunan/i.test(String(jenisBantuan || ''));
  if (tipe === 'administrasi' && Number(urutan) === 1 && isPembangunan) {
    return {
      ...base,
      fotoWajib: ['Foto 0% (Lokasi Tanah)'],
    };
  }

  const isRehab = /rehab/i.test(String(jenisBantuan || ''));
  if (tipe === 'administrasi' && Number(urutan) === 3 && isRehab) {
    return {
      ...base,
      dokumenWajib: (base.dokumenWajib || []).filter(label => !/gambar teknis/i.test(String(label))),
    };
  }
  return base;
}

export function parseFileArray(val) {
  if (!val) return [];
  try { return typeof val === 'string' ? JSON.parse(val) : val; } catch { return []; }
}

/**
 * Label dokumen keuangan langkah 1 (Dana diterima) yang disinkron dari ADM.
 * ADM 7 (Pemblokiran) -> slot 0 = Surat Pemblokiran ke Bank, 1 = Surat Pembuka Rekening (opsional)
 * ADM 8 (Transfer Dana) -> slot 0 = BAP, 1 = SPM, 2 = Kwitansi Pembayaran ke Penerima
 * File hasil sync diberi prefix `sync_adm<urutan>_i<index>_` pada nama file.
 */
export function getKeuanganSyncLabel(step, file, index) {
  const name = String(file || '');
  const m = name.match(/^sync_adm(\d+)_i(\d+)_/);
  if (!m) return null;
  const admUrutan = Number(m[1]);
  const srcIdx = Number(m[2]);
  if (admUrutan === 8) {
    if (srcIdx === 0) return 'BAP (ADM 8)';
    if (srcIdx === 1) return 'SPM (ADM 8)';
    if (srcIdx === 2) return 'Kwitansi Pembayaran ke Penerima (ADM 8)';
    return `Dokumen Transfer Dana (ADM 8)`;
  }
  if (admUrutan === 7) {
    if (srcIdx === 0) return 'Surat Pemblokiran Rekening (ADM 7)';
    return 'Surat Pembuka Rekening (ADM 7)';
  }
  return `Dokumen ADM ${admUrutan}`;
}

/**
 * Label foto per-slot untuk suatu langkah (administrasi/keuangan/fisik).
 * Contoh hasil: ["Foto Tampak Depan", "Foto Tampak Belakang", ...]
 * Jika foto lebih banyak dari template, sisanya diberi label "Foto N".
 */
export function getFotoLabels(tipe, step, files, jenisBantuan = '') {
  const list = Array.isArray(files) ? files : parseFileArray(files);
  const template = getTemplate(tipe, Number(step?.urutan), jenisBantuan);
  const fotoWajib = template?.fotoWajib || [];
  const tahap = step?.tahap || template?.tahap || '';
  
  // Untuk rehab fisik manual: gunakan nama tahap sebagai konteks label
  if (template?.isManualRehab) {
    return list.map((_, index) => {
      const stage = fotoWajib[index] || `dokumentasi ${index + 1}`;
      // Hindari duplikasi prefix "Foto"
      const cleanStage = /^foto\b/i.test(String(stage)) ? String(stage).replace(/^foto\s*/i, '') : stage;
      return tahap ? `Foto ${cleanStage} - ${tahap}` : `Foto ${cleanStage}`;
    });
  }
  
  return list.map((_, index) => {
    const label = fotoWajib[index];
    if (label) {
      // Hindari duplikasi prefix "Foto"
      return /^foto\b/i.test(String(label)) ? label : `Foto ${label}`;
    }
    // Fallback: sertakan nama tahap agar tetap informatif
    return tahap ? `Foto ${tahap} ${index + 1}` : `Foto ${index + 1}`;
  });
}

export function getDocumentLabels(tipe, step, files, jenisBantuan = '', supplierNames = []) {
  const list = Array.isArray(files) ? files : parseFileArray(files);
  const template = getTemplate(tipe, Number(step?.urutan), jenisBantuan);

  const getLabelByIndex = (index) => {
    const base = template?.dokumenWajib || [];
    // Keuangan: Pembayaran Supplier Tahap I/II → bukti transfer per masing-masing supplier
    if (tipe === 'keuangan' && template?.perSupplierBukti) {
      const nama = supplierNames[index] ? ` (${supplierNames[index]})` : ` ${index + 1}`;
      return `Bukti Transfer ke Supplier${nama}`;
    }
    return base[index];
  };

  return list.map((file, index) => {
    const name = String(file || '');
    if (name.startsWith('SK_')) return 'SK Penetapan (Sistem)';
    if (name.startsWith('BA_Signed_')) return 'Berita Acara Bertanda Tangan';
    if (name.startsWith('BA_Verifikasi_')) return 'Berita Acara Hasil Validasi';
    if (Number(step?.urutan) === 10 && tipe === 'administrasi') return `Dokumen SPJ ${index + 1}`;
    return getLabelByIndex(index) || `Dokumen ${index + 1}`;
  });
}
